/**
 * Shared helpers for PricingPanel components.
 */
/** Format cents as a dollar string: 900 → "$9", 950 → "$9.50" */
export function formatPrice(cents) {
    const dollars = cents / 100;
    return `$${dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2)}`;
}
/** Capitalize first letter: "pro" → "Pro" */
export function tierLabel(tier) {
    return tier.charAt(0).toUpperCase() + tier.slice(1);
}
/**
 * Compute the average annual savings percentage across paid tiers.
 * Skips free tier and tiers with zero monthly price.
 * Returns a rounded integer (e.g., 20 for ~20%).
 */
export function computeAnnualSavingsPercent(product) {
    if (!product)
        return 0;
    let totalDiscount = 0;
    let count = 0;
    for (const [key, info] of Object.entries(product.tiers)) {
        if (key === "free")
            continue;
        if (!info.active || info.monthlyPriceCents === 0)
            continue;
        const yearlyEquiv = info.monthlyPriceCents * 12;
        const discount = 1 - info.annualPriceCents / yearlyEquiv;
        totalDiscount += discount;
        count++;
    }
    if (count === 0)
        return 0;
    const avg = totalDiscount / count;
    // Round to nearest 5%
    return Math.round((avg * 100) / 5) * 5;
}
/**
 * Look up a product by ID in the catalog.
 */
export function findProduct(catalog, productId) {
    return catalog.products.find((p) => p.productId === productId);
}
/**
 * Resolve product IDs to display names using the catalog.
 * Falls back to the raw ID if the product isn't found.
 */
export function resolveProductNames(catalog, productIds) {
    return productIds.map((id) => {
        const product = catalog.products.find((p) => p.productId === id);
        return product?.displayName ?? id;
    });
}
